import { createLocalStorageStateHook } from 'use-local-storage-state';
import { IUserMe } from '../interfaces/user';

export const useUserMe = createLocalStorageStateHook<IUserMe>('userme');
